<template>
  <svg
    viewBox="0 0 49 48"
    xmlns="http://www.w3.org/2000/svg"
    width="49"
    height="48"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M27.4629 2.16539C28.2773 2.51892 28.7612 3.36706 28.6511 4.24806L26.9321 18H42.6665C43.4426 18 44.1485 18.4489 44.4777 19.1517C44.8069 19.8544 44.6998 20.6842 44.203 21.2804L24.203 45.2804C23.6346 45.9624 22.6846 46.1881 21.8701 45.8346C21.0557 45.4811 20.5718 44.6329 20.682 43.7519L22.401 30H6.66653C5.89049 30 5.18451 29.5511 4.85535 28.8483C4.52619 28.1455 4.63328 27.3158 5.13009 26.7196L25.1301 2.71962C25.6985 2.03755 26.6485 1.81185 27.4629 2.16539ZM10.9366 26H24.6665C25.2402 26 25.7862 26.2463 26.1659 26.6764C26.5455 27.1064 26.7222 27.6788 26.6511 28.2481L25.4972 37.4791L38.3964 22H24.6665C24.0929 22 23.5468 21.7537 23.1672 21.3236C22.7875 20.8935 22.6108 20.3212 22.682 19.7519L23.8358 10.5209L10.9366 26Z"
    />
  </svg>
</template>
